module.exports = __webpack_public_path__ + "img/waves.79d4bad0.svg";